import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
export function appRocketAppAdmin(globalStore, username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appRocketAppAdmin");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        handleClickOpen(event, username, bearerToken, userResponse.odDeskPreferences);
    });
}
function handleClickOpen(event, username, bearerToken, userPreferences) {
    const additionalClassList = [];
    const appGroupNode = document.getElementById('appGroups');
    if (appGroupNode)
        appGroupNode.classList.add('disabled');
    const fullScreenNode = document.getElementById('appFullscreen');
    if (fullScreenNode) {
        fullScreenNode.classList.remove('disabled');
        DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], "Schulverwaltung");
        let nodePupilSearch = DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolPupilSearch");
    }
    getBackendData(username, "/rocketchat/", "GET", "application/json", bearerToken, function (response) {
        const responseData = JSON.parse(response.target.response);
    });
}
